import React from 'react';
import { connect } from 'react-redux';
import FacilityTable from '../components/Facilities/FacilityTable';
import Breadcrumb from '../components/Common/Breadcrumb';

const Facilities = () => {
  return (
    <React.Fragment>
      <Breadcrumb items={[{ label: 'Facilities', link: '/facilities' }]} />
      <FacilityTable />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Facilities);
